export const selectUsageSettingsQueryParams = (state) =>
    state?.usageSettings?.queryParams;
